import { Badge as AntBadge, BadgeProps } from "antd";

export default function Badge(props: BadgeProps) {
  return <AntBadge {...props} data-test-id="badge" />;
}
